import styled from 'styled-components';
import { listControlTokens } from '../../tokens/components/ListControl/tokens';

export const MobileControlWrapper = styled.div`
  display: grid;
  gap: ${listControlTokens.SpacingHorizontalBaseDefault};

  /*
    On mobile screens, we want to stack the controls vertically, and stretch
    them to fill the width of the ListItem. This will work for most cases (i.e.
    buttons, inputs etc), but a minority of cases (e.g. Bubble) will require a
    change on the implementation. Wrapping the component in a Box should prevent
    it from stretching
  */
  & > * {
    width: 100%;
  }

  /*
    We want to change the order of the List subcomponents on mobile, so instead
    of having ListBody appear below ListControl, we want to switch the order, so
    we use grid-row: 3 to change the order (1st row is StyledListItem, 2nd is
    ListBody, and 3rd is ListControl). However, for cases where there is no
    ListBody (where ListControl is the last child), we want it to be the second
    row
  */
  grid-row: 3;

  &:last-child {
    grid-row: 2;
  }
`;
